export const parseNumberedList = (content) => {
  const lines = content.split('\n');
  const listItems = [];
  let listStartIndex = -1;
  let listEndIndex = -1;

  for (let i = 0; i < lines.length; i += 1) {
    const match = lines[i].match(/^(\d+)\.\s+(.+)$/);
    if (match) {
      if (listStartIndex === -1) listStartIndex = i;
      listEndIndex = i;
      listItems.push({
        number: match[1],
        text: match[2],
        fullText: match[2],
      });
    } else if (listStartIndex !== -1 && lines[i].trim() !== '') {
      break;
    }
  }

  if (listItems.length === 0) return null;

  const beforeList = lines.slice(0, listStartIndex).join('\n').trim();
  const afterList = lines.slice(listEndIndex + 1).join('\n').trim();
  const remainingText = [beforeList, afterList].filter(Boolean).join('\n\n');

  return { listItems, remainingText };
};
